import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M13 17l6 0","key":"svg-1"}]]

const IconPrompt = createReactComponent('outline', 'prompt', 'Prompt', __iconNode);

export default IconPrompt;